import {LogFile} from '../Types';
import { RootState, useAppSelector } from '../store';
import {complianceService} from '../Services/complianceService';
import {useState} from "react";
import {LogType} from "../Types/Enums";
import { getBreakpoint } from '../utils/breakpoint';

const useLogFiles = ({initialLogType}: {initialLogType: LogType}) => {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const windowWidth = useAppSelector((state: RootState) => state.environment.windowWidth);
    const [logType, setLogType] = useState<LogType>(initialLogType);


    async function download(logType: LogType, logFiles: LogFile[]) {
        const filenames = logFiles.map(lg => lg.name)

        // Fetch the file(s) from the API
        const response = await complianceService.downloadLogFiles(logType, filenames.join(','))

        // Get the filename from the Content-Disposition header
        const disposition = response.headers['content-disposition'];
        // Check if download failed
        if(disposition == null) {
            return
        }
        let filename = disposition
            .split('filename=')[1]
            .split(';')[0]
            .replace(/"/g, '')
            .trim();

        // Create a blob and trigger download
        const blob = await response.data;
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    function toLocalDateTime(datetime: string) {
        const date = new Date(datetime);

        const yyyy = date.getFullYear();
        const MM = String(date.getMonth() + 1).padStart(2, '0')
        const dd = String(date.getDate()).padStart(2, '0')
        const H = String(date.getHours()).padStart(2, '0')
        const m = String(date.getMinutes()).padStart(2, '0')
        const s = String(date.getSeconds()).padStart(2, '0')

        return `${yyyy}-${MM}-${dd} ${H}:${m}:${s}`
    }

    return {
        i18n,
        windowWidth,
        getBreakpoint,
        download,
        toLocalDateTime,
        logType,
        setLogType,
    };
};

export default useLogFiles;
